module.exports = __webpack_public_path__ + "static/media/team4.fcf31ea9.svg";